import { Inject, Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { APP_CONFIG } from '@boma/app-config';
import { IPaginatedResponse } from '@boma/administration-portal/shared/entities';
import { IBrand, IBrandAdd } from '@boma/shared/entities';

@Injectable({
  providedIn: 'root',
})
export class BrandsService {
  private base: string;
  private version: string;

  constructor(
    @Inject(APP_CONFIG) private configuration: any,
    private httpClient: HttpClient
  ) {
    this.base = configuration.apiRoute;
    this.version = configuration.apiVersion;
  }

  listBrands(page: string = '1', query: string = '', perPage: string = '150') {
    return this.httpClient.get<IPaginatedResponse<IBrand>>(
      `${this.base}api/v${this.version}/Brands`,
      {
        params: { page, perPage, query },
      }
    );
  }

  getBrandDetails(id: string) {
    return this.httpClient.get<IBrand>(
      `${this.base}api/v${this.version}/Brands/${id}`
    );
  }

  createBrand(brand: IBrandAdd) {
    return this.httpClient.post<IBrand>(
      `${this.base}api/v${this.version}/Brands`,
      {
        ...brand,
      }
    );
  }

  uploadBrandImage(file: File) {
    const formData = new FormData();
    formData.append('file', file, file.name);
    return this.httpClient.post<string>(
      `${this.base}api/v${this.version}/Brands/UploadImage`,
      formData
    );
  }

  updateBrand(category: any, brandId: string) {
    return this.httpClient.put<IBrand>(
      `${this.base}api/v${this.version}/Brands/${brandId}`,
      {
        ...category,
      }
    );
  }

  deleteBrand(brandId: string) {
    return this.httpClient.delete<HttpResponse<any>>(
      `${this.base}api/v${this.version}/Brands/${brandId}`
    );
  }
}
